import {InfoWindow} from '@react-google-maps/api';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';
import MapMarker, {circleIcon, defaultIcon, downtime1Icon, downtime2Icon} from '../../atoms/MapMarker';
import VesselInfo from '../../organisms/VesselInfo';
import {getPosition} from '../../utils/map';
import {hasDowntime} from '../../utils/systems';

const getDowntimeMarkerIcon = {
  1: downtime1Icon,
  2: downtime2Icon
};

const MapContent = ({systems, selectedSystem, onMarkerClick, onInfoWindowClose}) => {
  return (
    <>
      {systems.map(system => (
        <MapMarker
          location={system.location}
          key={system.id}
          onClick={() => onMarkerClick(system)}
          options={{
            zIndex: selectedSystem === system ? 999 : hasDowntime(system) ? 997 : undefined,
          }}
          icon={getDowntimeMarkerIcon[system.downtime] || defaultIcon}
        />
      ))}
      {selectedSystem && (
        <MapMarker
          location={selectedSystem.location}
          icon={circleIcon}
          options={{
            zIndex: 998,
          }}
        />
      )}
      {selectedSystem && (
        <InfoWindow
          position={getPosition(selectedSystem.location)}
          onCloseClick={onInfoWindowClose}
          options={{
            pixelOffset: {width: 0, height: -28},
          }}
        >
          <VesselInfo system={selectedSystem} style={{width: '360px'}}/>
        </InfoWindow>
      )}
    </>
  );
};

MapContent.propTypes = {
  systems: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedSystem: PropTypes.object,
  onMarkerClick: PropTypes.func,
  onInfoWindowClose: PropTypes.func,
  location: PropTypes.object,
};

export default withRouter(MapContent);
